function setSlider() {
	let dataArr = [];
	let data = new Date();
	let year = data.getFullYear();
	data.setMonth(data.getMonth() + 1, 1) //获取到当前月份,设置月份
	for (let i = 0; i < 12; i++) {
		data.setMonth(data.getMonth() - 1); //每次循环一次 月份值减1
		let m = data.getMonth() + 1;
		m = m < 10 ? "0" + m : m;
		dataArr.push(data.getFullYear() + "/" + (m))

	}
	let obj = {}
	dataArr.reverse().forEach((item, index) => {

		obj[parseInt((index * .9) * 10)] = item
	})

	return obj

};
function setSlider1() {
	let dataArr = [];
	let data = new Date();
	let year = data.getFullYear();
	data.setMonth(data.getMonth() + 1, 1) //获取到当前月份,设置月份
	for (let i = 0; i < 12; i++) {
		data.setMonth(data.getMonth() - 1); //每次循环一次 月份值减1
		let m = data.getMonth() + 1;
		//m = m < 10 ? "0" + m : m;
		if (i == 0) {
			dataArr.push(data.getFullYear() + "/" + (m))
		} else if (i == 11) {
			dataArr.push(data.getFullYear() + "/" + (m))
		} else {
			dataArr.push("" + (m))
		}

	}
	let obj = {}

	dataArr.reverse().forEach((item, index) => {
		obj[parseInt((index * .9) * 10)] = item
	})

	return obj

};
// 一年的日期只有年月 例：2020/01 - 2021/01
let sliderMarks = setSlider();
let sliderMarks1 = setSlider1();

//设置日期
function dataNumbers(day) {
	let today = new Date();
	let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
	today.setTime(targetday_milliseconds);
	let tYear = today.getFullYear();
	let tMonth = today.getMonth();
	let tDate = today.getDate();
	return tYear + "-" + parseInt(tMonth + 1) + "-" + tDate;
}
//获取具体日期
function dataNumber(day) {
	let today = new Date(day);
	let tYear = today.getFullYear();
	let tMonth = today.getMonth();
	let tDate = today.getDate();
	return tYear + "-" + parseInt(tMonth + 1) + "-" + tDate;
}
//获取上个周期的初始时间  
function getLastBeginMonth(m) {
	if (parseInt(m) > 0) { //m是 往前推的总月份
		let myDate = new Date();
		let year = myDate.getFullYear(); //获取当前年
		let month = myDate.getMonth() + 1; //获取当前月
		let day = myDate.getDate(); //获取当前日
		let lowData = ''; //当前年月日往前推m个月后获取到的年月日
		let ylow = parseInt(parseInt(m) / 12); //往前推的总月份换成对应的年数取整
		let mlow = parseInt(m) % 12; //往前推的月数
		let sameMonth = (month < 10 ? "0" + month : month);
		let sameYear = year;
		if (ylow > 0) {
			year -= ylow; //年要再减一
		} else {
			year = year; //年取当前年份
		}
		if ((mlow > month) || (mlow == month)) { //往前推的月份大于或等于当前月份，12减去往前推的月份加上现在的月份
			year = year - 1;
			month = 12 - mlow + month;
			lowData = year + '/' + month
		} else { //往前推的月份小于当前月份
			month -= mlow;
			lowData = year + '/' + month
		}
		let arr = [];
		arr.push(lowData);
		arr.push(sameYear + "/" + sameMonth);
		return {
			startdt: lowData,
			enddt: sameYear + "/" + sameMonth,
			dataArr: arr
		}
	} else {
		return m;
	}
}

// 年月日，已转译 例：2020-2-1 
let startDate = dataNumbers(-360)
let endDate = dataNumbers(0)

// 年月日 未转译 例：Tue Jan 26 2021 09:45:52 GMT+0800 (中国标准时间)
const end = new Date();
const start = new Date();
start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);

function p(s) {
  return s < 10 ? '0' + s : s
}

function d(d){
	return d.getFullYear() + '-' + p((d.getMonth() + 1)) + '-' + p(d.getDate())
}

// 计算两日期间的天数
function  getDaysBetween(dateString1,dateString2){
    var  startDate = Date.parse(d(dateString1));
    var  endDate = Date.parse(d(dateString2));
    if (startDate>endDate){
        return 0;
    }
    if (startDate==endDate){
        return 1;
    }
    var days=(endDate - startDate)/(1*24*60*60*1000);
    return  days;
}

// 格式化成2020/02
function mouthformat(val,connect){
	  //初始化成日期对象
	  const d = new Date(val)
	  //拼接成2020-06
	  const strMonth = d.getFullYear() + connect +  addZeroPrefixForMonth(d.getMonth() + 1);
	  return strMonth;
}
//月份 9 => 09
function addZeroPrefixForMonth(month){
	return month < 10 ? '0' + month : month
}
export default {
  sliderMarks,
  sliderMarks1,
  startDate,
  endDate,
  end,
  start,
  dataNumber,
  dataNumbers,
  getLastBeginMonth,
  getDaysBetween,
  mouthformat
}
